export default function DevText({ children }: { children: string }) {
    return (
        <textarea
            readOnly
            wrap="off"
            value={children}
            className="h-64 w-full resize-none overflow-auto rounded border bg-slate-100 p-2 font-mono text-sm"
        />
    )
}
